const urlParams = new URLSearchParams(window.location.search);

const offerCutoffDate = new Date(2022, 5, 30, 0, 0, 0);
const dateOptions = {
  month: "long",
  day: "numeric",
  year: "numeric"
};

export default {
  en: {
    nav: {
      lang: "Language",
      en: "English",
      es: "Spanish",
      pt: "Português"
    },
    masthead: {
      title: "We're glad you're here.",
      subtitle: "Tell us your preferences for a free* rental day.",
      thankstitle: "Thank You!",
      thankssubtitle: `One free day* on your next rental. <a target="_blank" href="https://offer.hertz.com/offers/index.jsp?targetPage=SourceLAMCFREEDayUS.jsp&id=66191&gclid=${urlParams.get(
        "gclid"
      ) || ""}&utm_content=${urlParams.get("utm_content") ||
        "m8-email"}">Enjoy&nbsp;your&nbsp;offer&nbsp;&gt;</a>`
    },
    destinations: {
      title: "Select your top destination",
      error: "Please answer each highlighted field.",
      eu: "Europe",
      us: "US",
      can: "Canada"
    },
    options: {
      title: "Tell us about how you travel.",
      required: "All fields required.",
      action: "Submit"
    },
    thanks: {
      title: `Receive one FREE rental day* on bookings of 7 days or more, for pickups by ${offerCutoffDate.toLocaleDateString(
        "en-US",
        dateOptions
      )} at participating locations in the U.S.`,
      subtitle: "*Taxes & fees excluded. Terms apply.",
      legal:
        '<p class="legal">Terms & Conditions</p><p class="legal">An advance reservation is required at least 24 hours before departure from Latin American and the Caribbean and must include the PC for this offer.  Modifying your reservation may result in a change in your rate and/or disqualify the use of this offer. Subject to availability, this offer is redeemable at participating Hertz locations in the U.S. & Canada.  This offer has no cash value, may not be used with Pre-pay Rates, Tour Rates or Insurance Replacement Rates.</p><p class="legal">No other certificate, voucher, offer or promotion applies. Hertz age, driver, credit and qualifying rate restrictions for the renting location apply.  Taxes, tax reimbursement, age differential charges, fees and optional service charges, such as refueling, are not included.  Discounts apply to time and mileage charges only.  Discounts in local currency on redemption.  Offer valid for vehicle pickup through 6/30/2019.</p>',
      action: "Enjoy your offer",
      action_link: `https://offer.hertz.com/offers/index.jsp?targetPage=SourceLAMCFREEDayUS.jsp&id=66191&gclid=${urlParams.get(
        "gclid"
      ) || ""}&utm_content=${urlParams.get("utm_content") || "m8-email"}`
    },
    socials: {
      fb: "",
      tw: "",
      ig: "",
      yt: ""
    },
    sitemap: {
      reservations: "Reservations&nbsp;&gt;",
      reservations_link: "/",
      contact: "Contact&nbsp;Us&nbsp;&gt;",
      contact_link: "/",
      privacy: "Privacy&nbsp;Policy&nbsp;&gt;",
      privacy_link: "/",
      offers: "Offers&nbsp;&gt;",
      offers_link: "/"
    },
    legal: {
      policy: "Privacy&nbsp;Policy",
      policy_link: "/",
      copy: "&copy; 2019 Hertz System, Inc. All rights reserved."
    }
  },
  es: {
    nav: {
      lang: "Idioma",
      en: "English",
      es: "Spanish",
      pt: "Português"
    },
    masthead: {
      title: "Estamos contentos de que esté aquí.",
      subtitle: "Díganos sus preferencias por un día de alquiler GRATIS.*",
      thankstitle: "¡Gracias!",
      thankssubtitle: `Reciba un día* gratis en su próximo alquiler. <a target="_blank" href="https://offer.hertz.com/offers/index.jsp?targetPage=SourceLAMCFREEDayUS.jsp&id=66191&dialect=esLA&gclid=${urlParams.get(
        "gclid"
      ) || ""}&utm_content=${urlParams.get("utm_content") ||
        "m8-email"}">Disfrute&nbsp;su&nbsp;oferta&nbsp;&gt;</a>`
    },
    destinations: {
      title: "Seleccione su destino principal",
      error: "Por favor, responda cada campo resaltado.",
      eu: "Europa",
      us: "Estados Unidos",
      can: "Canadá"
    },
    options: {
      title: "Cuéntanos cómo usted viaja.",
      required: "Todos los campos son obligatorios.",
      action: "ENVIAR"
    },
    thanks: {
      title: `Reciba un día de alquiler GRATIS* en reservas de 7 días o más, para retiradas hasta el ${offerCutoffDate.toLocaleDateString(
        "es-US",
        dateOptions
      )} en localidades participantes en USA.`,
      subtitle:
        "*Los impuestos y cargos son adicionales. Se aplican otras restricciones.",
      legal:
        '<p class="legal">Terms & Conditions</p><p class="legal">An advance reservation is required at least 24 hours before departure from Latin American and the Caribbean and must include the PC for this offer.  Modifying your reservation may result in a change in your rate and/or disqualify the use of this offer. Subject to availability, this offer is redeemable at participating Hertz locations in the U.S. & Canada.  This offer has no cash value, may not be used with Pre-pay Rates, Tour Rates or Insurance Replacement Rates.</p><p class="legal">No other certificate, voucher, offer or promotion applies. Hertz age, driver, credit and qualifying rate restrictions for the renting location apply.  Taxes, tax reimbursement, age differential charges, fees and optional service charges, such as refueling, are not included.  Discounts apply to time and mileage charges only.  Discounts in local currency on redemption.  Offer valid for vehicle pickup through 6/30/2019.</p>',
      action: "DISFRUTE SU OFERTA",
      action_link: `https://offer.hertz.com/offers/index.jsp?targetPage=SourceLAMCFREEDayUS.jsp&id=66191&dialect=esLA&gclid=${urlParams.get(
        "gclid"
      ) || ""}&utm_content=${urlParams.get("utm_content") || "m8-email"}`
    },
    socials: {
      fb: "",
      tw: "",
      ig: "",
      yt: ""
    },
    sitemap: {
      reservations: "Reservas&nbsp;&gt;",
      reservations_link: "/",
      contact: "Contáctenos&nbsp;&gt;",
      contact_link: "/",
      privacy: "Política&nbsp;de&nbsp;confidencialidad&gt;",
      privacy_link: "/",
      offers: "Ofertas&nbsp;&gt;",
      offers_link: "/"
    },
    legal: {
      policy: "Política&nbsp;de&nbsp;confidencialidad",
      policy_link: "/",
      copy: "&copy; Hertz System, Inc. Todos los derechos reservados."
    }
  },
  pt: {
    nav: {
      lang: "Idiom",
      en: "English",
      es: "Spanish",
      pt: "Português"
    },
    masthead: {
      title: "Estamos felizes por você estar aqui.",
      subtitle:
        "Conte-nos suas preferências para obter um dia de locação GRÁTIS*",
      thankstitle: "Obrigado!",
      thankssubtitle: `Receba um dia* GRATIS de locação. <a target="_blank" href="https://offer.hertz.com/offers/index.jsp?targetPage=SourceLAMCFREEDayUS.jsp&id=66191&dialect=ptBR&gclid=${urlParams.get(
        "gclid"
      ) || ""}&utm_content=${urlParams.get("utm_content") ||
        "m8-email"}">Aproveite sua oferta &gt;</a>`
    },
    destinations: {
      title: "Selecione seu destino principal",
      error: "Por favor, responda a cada campo destacado.",
      eu: "Europe",
      us: "US",
      can: "Canada"
    },
    options: {
      title: "Conte-nos sobre como você viaja.",
      required: "Todos os campos são necessários.",
      action: "ENVIAR"
    },
    thanks: {
      title: `Receba um dia de locação GRÁTIS* nas reservas de 7 dias ou mais com retiradas até ${offerCutoffDate.toLocaleDateString(
        "pt-BR",
        dateOptions
      )} nas lojas participantes, nos EUA.`,
      subtitle: "* Exclui impostos e taxas. Aplicam-se termos.",
      legal:
        '<p class="legal">Terms & Conditions</p><p class="legal">An advance reservation is required at least 24 hours before departure from Latin American and the Caribbean and must include the PC for this offer.  Modifying your reservation may result in a change in your rate and/or disqualify the use of this offer. Subject to availability, this offer is redeemable at participating Hertz locations in the U.S. & Canada.  This offer has no cash value, may not be used with Pre-pay Rates, Tour Rates or Insurance Replacement Rates.</p><p class="legal">No other certificate, voucher, offer or promotion applies. Hertz age, driver, credit and qualifying rate restrictions for the renting location apply.  Taxes, tax reimbursement, age differential charges, fees and optional service charges, such as refueling, are not included.  Discounts apply to time and mileage charges only.  Discounts in local currency on redemption.  Offer valid for vehicle pickup through 6/30/2019.</p>',
      action: "APROVEITE SUA OFERTA",
      action_link: `https://offer.hertz.com/offers/index.jsp?targetPage=SourceLAMCFREEDayUS.jsp&id=65327&id=66191&dialect=ptBR&gclid=${urlParams.get(
        "gclid"
      ) || ""}&utm_content=${urlParams.get("utm_content") || "m8-email"}`
    },
    socials: {
      fb: "",
      tw: "",
      ig: "",
      yt: ""
    },
    sitemap: {
      reservations: "Reservas&nbsp;&gt;",
      reservations_link: "/",
      contact: "Contate-nos&nbsp;&gt;",
      contact_link: "/",
      privacy: "Confidencialidade&nbsp;&gt;",
      privacy_link: "/",
      offers: "Ofertas&nbsp;&gt;",
      offers_link: "/"
    },
    legal: {
      policy: "Confidencialidade",
      policy_link: "/",
      copy: "&copy; Hertz System, Inc. Todos os direitos reservados."
    }
  }
};
